var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"icon-list"},_vm._l((_vm.list),function(item){return _c('li',{key:item,on:{"click":function($event){return _vm.copyItem(item)}}},[_c('span',[_c('i',{class:item}),_c('span',{staticClass:"icon-name"},[_vm._v(_vm._s(item))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }